import { Component, OnInit } from '@angular/core';
import { MonthlyExpensesService } from '../../services/monthly-expenses.service';
import { SharedService } from 'app/modules/common/services/shared-service';
import { FileExportService } from 'app/modules/selection-generic/services/file-export.service';

@Component({
    selector: 'app-expenses-header',
    templateUrl: './expenses-header.component.html',
    styleUrls: ['./expenses-header.component.scss'],
    standalone: false
})
export class ExpensesHeaderComponent implements OnInit {

  constructor(public monthlyExpensesSerivce: MonthlyExpensesService,
              private sharedService: SharedService,
              private fileExportService: FileExportService) { }

  ngOnInit(): void {
  }

  loadNewMonth(): void {
    this.monthlyExpensesSerivce.loadNewMonth().subscribe(res => {
      if (res.code === 0) {
        this.monthlyExpensesSerivce.updateExpensesList(this.monthlyExpensesSerivce.selectedDatePeriod);
        this.sharedService.ShowSnackBar('Mes cargado con éxito', 'okay', 2000);
      } else {
        this.sharedService.ShowSnackBar('Error al cargar el mes', 'okay', 2000);
      }
    }, error => {
      this.sharedService.ShowSnackBar('Error al cargar el mes', 'okay', 2000);
      console.error(error);
    });
  }

  trasferExpenses(): void {
    let expensesList = this.monthlyExpensesSerivce.expensesList.data;
    if (expensesList.length > 0) {
      this.monthlyExpensesSerivce.isListLoading = true;
      expensesList = expensesList.filter(e => e.traspasado === 'N');
      this.monthlyExpensesSerivce.transferExpenses(expensesList).subscribe(res => {
        if (res.code === 0) {
          this.sharedService.ShowSnackBar('Transferido con éxito', 'okay', 2000);
        } else {
          this.sharedService.ShowSnackBar('Transferencia fallida', 'okay', 2000);
        }
        this.monthlyExpensesSerivce.isListLoading = false;
        this.monthlyExpensesSerivce.updateExpensesList(this.monthlyExpensesSerivce.selectedDatePeriod);
      }, error => {
        this.sharedService.ShowSnackBar('Transferencia fallida', 'okay', 2000);
        this.monthlyExpensesSerivce.isListLoading = false;
        this.monthlyExpensesSerivce.updateExpensesList(this.monthlyExpensesSerivce.selectedDatePeriod);
        console.error(error);
      });
    }
  }

  downloadCoordinadores(): void {
    this.monthlyExpensesSerivce.isListLoading = true;
    this.monthlyExpensesSerivce.downloadCoordinadores().subscribe(res => {

      if (res.code === 0 && res.result.file !== null && res.result.file !== undefined) {
        this.fileExportService.DownloadFile(res.result.file, res.result.fileName);
      } else {
        this.sharedService.ShowSnackBar('Error al recuperar la lista de coordinadores', 'Okay', 2000);
      }
      
      this.monthlyExpensesSerivce.isListLoading = false;
    }, error => {
      this.sharedService.ShowSnackBar('Error al recuperar la lista de coordinadores', 'okay', 2000);
      this.monthlyExpensesSerivce.isListLoading = false;
      console.error(error);
    });
  }

}
